/**
 * @generated SignedSource<<141a18e18519e803bef83ce2b35d5efd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ActivityStatusIndicatorPresence_agent$data = {
  readonly liveChatActivitiesBySpace: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly activityStatus: string;
      } | null;
    }>;
  } | null;
  readonly " $fragmentType": "ActivityStatusIndicatorPresence_agent";
};
export type ActivityStatusIndicatorPresence_agent$key = {
  readonly " $data"?: ActivityStatusIndicatorPresence_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityStatusIndicatorPresence_agent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ActivityStatusIndicatorPresence_agent",
  "selections": [
    {
      "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
      "kind": "LinkedField",
      "name": "liveChatActivitiesBySpace",
      "plural": false,
      "selections": [
        {
          "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "CustomerServiceSpaceLiveChatActivity",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "activityStatus"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "CustomerServiceLiveChatAgent"
};

(node as any).hash = "4bd38e5c35b0d146a1cf602bd64dc716";

export default node;
